import streamMessagesReducer from 'utils/messages/StreamMessage';
import {
    StreamDisableRangeElement,
    StreamMessageElement,
} from 'communication/types/StreamElement';
import {
    ObvTileDataElement,
    ObvTileTimeElement,
    ObvTileTimeSeriesElement,
} from 'widgets/obvTile/api/ObvTileElement';
import {
    ObvTileDataState,
    ObvTileDataStateTimeSeriesItem,
    ObvTileStreamState,
    initialObvTileDataState,
    initialObvTileStreamState,
} from 'widgets/obvTile/store/stream/ObvTileStreamState';

import timeSeriesReducer from 'utils/timeseries/timeSeriesUtils';
import disableRangeReducer from 'widgets/store/disableRange/StreamDisableRangeDataState';

import omitUndefined from 'utils/omitUndefined';
import { mapSessionBoundary } from 'utils/timeseries/TimeSeriesDisableRange';
import { StreamElementType } from 'communication/types/StreamElementType';
import { buildStreamedDataStreamSlice } from 'streamsState/store/streamedData/streamSlice';
import {
    createObvTileRequestUid,
    toObvRequestUid,
} from 'widgets/obvTile/api/ObvTileStreamRequest';
import State from 'store/State';
import { selectStreamedDataState } from 'streamsState/store/streamedData/selectors';

const processDataStreamElement = (
    element: ObvTileDataElement,
    nextState: ObvTileStreamState
) => {
    const nextDataState: ObvTileDataState = nextState.data ?? {
        ...initialObvTileDataState,
    };
    timeSeriesReducer(
        element as ObvTileTimeSeriesElement,
        nextDataState,
        mapToObvTileDataTimeSeriesItemFromElement
    );
    streamMessagesReducer(element as StreamMessageElement, nextState);
    disableRangeReducer(element as StreamDisableRangeElement, nextDataState);
    if (element._c === StreamElementType.OrderStat) {
        nextDataState.orderStat = {
            previousNightClose: element.p,
            exchangeRate: element.x,
            currencyCode: element.curr,
        };
    }
};

function mapToObvTileDataTimeSeriesItemFromElement(
    element: ObvTileTimeElement
): ObvTileDataStateTimeSeriesItem {
    return omitUndefined({
        close: element.c,
        volume: element.v,
        obv: element.obv,
        ...mapSessionBoundary(element),
    });
}

const selectObvStreamedData = (state: State) =>
    selectStreamedDataState(state).obvTiles;

const buildObvStreamSlice = () =>
    buildStreamedDataStreamSlice(
        'startObvChartStream',
        initialObvTileStreamState,
        selectObvStreamedData,
        createObvTileRequestUid,
        toObvRequestUid,
        processDataStreamElement
    );

const { reducer: obvStreamedDataReducer, selectors: obvStreamedDataSelectors } =
    buildObvStreamSlice();

export { obvStreamedDataReducer, obvStreamedDataSelectors };
